import { Controller } from "@hotwired/stimulus"

// Native <input type="search"> fires `search` on clear (X). WebKit fires it before the value clears,
// so we defer and rebuild the URL from the form: keep limit/sort/direction/starts_with, drop cleared keys.
// clearParamKeysValue is comma-separated GET param names to strip when the field is empty (e.g. "q,starts_with").
export default class extends Controller {
  static targets = ["queryInput"]
  static values = {
    clearParamKeys: { type: String, default: "q,starts_with" },
    turboFrame: { type: String, default: "index_results" }
  }

  clearNativeSearch() {
    if (!this.hasQueryInputTarget) return

    const input = this.queryInputTarget

    setTimeout(() => {
      if (input.value !== "") return

      const form = input.form
      if (!form) return

      const adminRoot = document.getElementById("admin-dashboard-root")
      if (adminRoot) {
        const spinner = this.application.getControllerForElementAndIdentifier(adminRoot, "spinner-overlay")
        spinner?.show()
      }

      const url = new URL(form.action, window.location.origin)
      url.search = ""

      const skip = new Set(
        this.clearParamKeysValue.split(",").map((k) => k.trim()).filter(Boolean)
      )

      for (const [key, value] of new FormData(form).entries()) {
        if (skip.has(key) || key === "button") continue
        if (value === "") continue
        url.searchParams.append(key, value)
      }

      const path = `${url.pathname}${url.search}`
      const link = document.createElement("a")
      link.href = path
      link.setAttribute("data-turbo-frame", this.turboFrameValue)
      link.setAttribute("data-turbo-action", "advance")
      link.classList.add("hidden")
      document.body.appendChild(link)
      link.click()
      link.remove()
    }, 0)
  }
}
